/**
 * Scroll a parent element to its child
 * @param  {String} elementSelector - Element selector to which the parent will scroll
 * @param  {String} parentSelector - Parent selector containing the element selector
 */
function scrollIntoView(
  elementSelector,
  parentSelector = 'html, body',
  speed = 500,
) {
  $(document).ready(() => {
    $(parentSelector).animate(
      {
        scrollTop: $(elementSelector).offset().top,
      },
      speed,
    );
  });
}

export default scrollIntoView;
